"use client";

import React from "react";

import { Card } from "@/components/flowbite/card";

import { ClusterSelectionPanelLayout } from "../cluster-selection/cluster-selection-panel-layout";
import { ClusterSelectionSummarySkeleton } from "../cluster-selection/cluster-selection-summary-skeleton";
import { SkeletonBox } from "../skeleton-box";

const ZONE_CARD_ROW_COUNT = 5;

interface ZonesPanelSkeletonProps {
  /** When false, omit Summary metric cards (map-level custom layers zones). Default true. */
  showSummary?: boolean;
}

function ZoneListItemCardSkeleton() {
  return (
    <Card className="flex w-full items-center gap-1 py-1 pl-3 pr-2">
      <SkeletonBox className="h-10 w-10 shrink-0 rounded" />
      <SkeletonBox className="h-4 min-w-0 flex-1" />
      <SkeletonBox className="h-5 w-5 shrink-0 rounded" />
    </Card>
  );
}

const ZonesPanelSkeletonComponent: React.FC<ZonesPanelSkeletonProps> = ({
  showSummary = true,
}) => {
  return (
    <ClusterSelectionPanelLayout>
      {showSummary ? <ClusterSelectionSummarySkeleton metricCount={2} /> : null}
      <div className={showSummary ? "mt-2 flex flex-col gap-2" : "flex flex-col gap-2"}>
        {Array.from({ length: ZONE_CARD_ROW_COUNT }, (_, index) => (
          <ZoneListItemCardSkeleton key={index} />
        ))}
      </div>
    </ClusterSelectionPanelLayout>
  );
};

export const ZonesPanelSkeleton = React.memo(ZonesPanelSkeletonComponent);
